module.exports = __webpack_public_path__ + "img/Apoptosis-OVCA_10X_WTA.5f48dec7.png";